import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-between q-mb-md" }
const _hoisted_2 = { class: "row items-start member-detail-header-left" }
const _hoisted_3 = { class: "member-detail-card-name q-mb-none q-ml-md" }
const _hoisted_4 = {
  key: 0,
  class: "col member-detail-card-date"
}
const _hoisted_5 = { class: "no-gutters q-ml-sm" }
const _hoisted_6 = {
  class: "work-detail-sub q-mt-xs row",
  style: {"width":"100%"}
}
const _hoisted_7 = {
  class: "q-mb-none member-detail-card-content",
  style: {"letter-spacing":"1px"}
}
const _hoisted_8 = { class: "work-detail q-mt-sm row" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "q-mb-none member-detail-card-content" }
const _hoisted_11 = { class: "row right-row" }
const _hoisted_12 = { class: "q-mb-none member-detail-card-content" }
const _hoisted_13 = {
  class: "work-detail q-mt-sm row address-wrapper",
  style: {"width":"100%"}
}
const _hoisted_14 = { class: "member-detail-card-content row" }
const _hoisted_15 = { class: "q-mb-none addressnumber-area" }
const _hoisted_16 = { class: "q-mb-none address-area" }
const _hoisted_17 = { class: "work-detail q-mt-sm row" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "q-mb-none member-detail-card-content" }
const _hoisted_20 = { class: "row right-row" }
const _hoisted_21 = { class: "member-detail-card-content" }

import ApprovalLabel from '../label/ApprovalLabel.vue';
import AttributeLabel from '../label/AttributeLabel.vue';

// どの画面で使用しているかでもらう値を判別
interface Props {
  // 会員情報
  data: {
    approval_stat: string;
    auth_level: string;
    user_id: string;
    user_name_mei: string;
    user_name_sei: string;
    customer_cd: string;
    mail_address: string;
    phone_number: string;
    work_school_name: string;
    affiliation_department_name: string;
    postal_cd: string;
    todohuken_name: string;
    street_address: string;
    quote_request_mail1: string;
    quote_request_mail2: string;
    quote_request_mail3: string;
    quote_request_mail4: string;
    update_timestamp: string;
    user_attribute: string;
  };
  // 表示モード
  mode: string;
}
const blank = '　';

export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDetailCard',
  props: {
    data: {},
    mode: {}
  },
  setup(__props: any) {

const MODE_TYPE = {
  // 会員情報
  MEMBER_INFO: 'memberinfo',
  // 承認設定
  MEMBER_APPROVAL: 'memberapproval',
};
const props = __props;

// user_name_seiとuser_name_meiの間に入れる空白

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass('member-detail-card ' + (_ctx.mode === MODE_TYPE.MEMBER_APPROVAL ? 'approval-card' : '')),
    style: {"padding-bottom":"12px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (props.mode !== MODE_TYPE.MEMBER_INFO)
                ? (_openBlock(), _createBlock(ApprovalLabel, {
                    key: 0,
                    class: "q-mr-sm account-label",
                    admin: props.data.auth_level,
                    approval: props.data.approval_stat
                  }, null, 8, ["admin", "approval"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_3, _toDisplayString(props.data.user_name_sei) + _toDisplayString(blank) + _toDisplayString(props.data.user_name_mei), 1)
            ]),
            (props.mode !== MODE_TYPE.MEMBER_INFO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("label", { class: "member-detail-card-item q-mr-md" }, "更新日時", -1)),
                  _createElementVNode("span", null, _toDisplayString(props.data.update_timestamp === null
              ? ''
              : props.data.update_timestamp.replace('-', '/').replace('-', '/')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "member-detail-card-item" }, "会員ID（メールアドレス）", -1)),
              _createElementVNode("p", _hoisted_7, _toDisplayString(props.data.mail_address), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "member-detail-card-item" }, "勤務先 / 学校名", -1)),
                _createElementVNode("p", _hoisted_10, _toDisplayString(props.data.work_school_name), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "member-detail-card-item" }, "所属 / 学部名", -1)),
                _createElementVNode("p", _hoisted_12, _toDisplayString(props.data.affiliation_department_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "member-detail-card-item" }, "所属先住所", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(props.data.postal_cd === null ? '' : '〒') + _toDisplayString(props.data.postal_cd), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(props.data.todohuken_name) + _toDisplayString(props.data.street_address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "member-detail-card-item" }, "所属先電話番号", -1)),
                _createElementVNode("p", _hoisted_19, _toDisplayString(props.data.phone_number), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "member-detail-card-item" }, "ご担当", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(AttributeLabel, {
                    attribute: props.data.user_attribute
                  }, null, 8, ["attribute"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})